import { useState } from 'react';
import { getZoomAuthUrl } from 'wisestep-api';
import { WsAccountNotFoundCard, WsPageHeader, ZoomLoader } from 'wisestep-base';

import {
  useSmsConfigAccessControl,
  SmsConfigAction,
} from '../../../hooks/useSmsConfigAccessControl';
import Zoom from '../../../images/icons/Zoom.png';
import { failed, warning } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';

export interface IAddZoomAccountProps {
  getAccounts: () => Promise<void>;
  setModal: any;
  unMarkModalState: () => Promise<void>;
}

const AddZoomAccount = ({ getAccounts, setModal, unMarkModalState }: IAddZoomAccountProps) => {
  const [loader, setLoader] = useState<boolean>(false);
  const setNotification = useNotificationStore((state) => state.setNotification);
  const { access, owns } = useSmsConfigAccessControl([SmsConfigAction.MANAGE_SMS_CONFIGURATION]);
  const [manageSmsConfig] = access;

  const getUrl = async () => {
    if (!(owns || manageSmsConfig)) {
      setNotification(warning("You don't have enough permission"));
      return;
    }
    setLoader(true);
    unMarkModalState();
    getZoomAuthUrl()
      .then((response) => {
        window.location.href = response?.data?.url;
        setLoader(true);
        getAccounts();
      })
      .catch((err) => {
        setLoader(false);
        console.log('Error while adding account is ', err);
        setNotification(failed('Error: while adding zoom account!'));
        setModal(false);
      });
  };
  return loader ? (
    <ZoomLoader />
  ) : (
    <>
      <WsPageHeader
        title="Zoom"
        profileImg={{ profileImage: Zoom, required: true }}
        buttonTitle="Add account"
        onButtonClick={getUrl}
        transparent={true}
      />
      <WsAccountNotFoundCard account="Zoom" />
    </>
  );
};

export default AddZoomAccount;
